var _path, _g, _path2, _path3, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeAboutIcon1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_289",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 74,
    height: 74
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H74V74H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4799 39.1289L14.1351 42.7768L16.1847 50.3994L22.3387 52.0442L23.8115 52.4373L29.3991 58.0148L35.1341 56.4726L37.0231 55.9639L38.8601 56.4553L44.65 58.0018L50.2275 52.4142L51.6583 52.0297L57.8515 50.3647L59.8881 42.7378L65.4654 37.1502L63.416 29.5262L65.4525 21.8993L59.8648 16.3218L57.8154 8.69781L53.5171 7.55023L50.1884 6.66137L46.0823 2.56246L44.6009 1.0839L36.9769 3.13336L29.3501 1.09691L23.7726 6.68449L16.1486 8.73394L14.112 16.3609L8.53455 21.9484L10.5841 29.571L9.29333 34.4056",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5605 62.861L56.318 69.4198L48.6752 66.9902L43.2712 72.916L38.8601 56.4554",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2944 58.1377L51.6583 52.0298",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8_289",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 74,
    height: 74
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H74V74H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8_289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1343 56.4728L30.7283 72.9161L25.3246 66.9905L17.6818 69.4198L22.3387 52.0437",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7028 37.9839H46.8119C48.0368 37.9839 49.0301 38.977 49.0301 40.2021C49.0301 41.427 48.0368 42.42 46.8119 42.42H34.9153C34.3162 42.42 33.7365 42.2171 33.261 41.8526C32.007 40.891 30.6802 40.6874 29.0673 40.5916V26.4871C32.8605 22.1533 37.6669 21.7461 37.3305 15.2701C37.2724 14.1496 38.1654 13.2087 39.2875 13.2087C40.1459 13.2087 40.909 13.7659 41.1593 14.5866C42.1774 17.9234 42.4319 21.2351 41.0881 24.6755H49.1995C50.4246 24.6755 51.4176 25.6686 51.4176 26.8936C51.4176 28.1187 50.4246 29.1117 49.1995 29.1117H46.4403H48.4485C49.6735 29.1117 50.6666 30.1047 50.6666 31.3297C50.6666 32.5548 49.6735 33.5478 48.4485 33.5478H46.4403H47.7112C48.9361 33.5478 49.9292 34.5409 49.9292 35.7658C49.9292 36.9909 48.9361 37.9839 47.7112 37.9839H45.7028Z",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0673 26.7386V40.8431",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0708 43.0067H29.0675V23.9539H16.1046",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0823 9.91777C43.3205 8.63722 40.2434 7.92324 37 7.92324C26.9912 7.92324 18.5708 14.722 16.1051 23.9532C15.6282 25.7382 15.3738 27.6142 15.3738 29.5494C15.3738 34.6369 17.1298 39.314 20.071 43.0068C24.0312 47.9844 30.1434 51.1757 37 51.1757C48.9441 51.1757 58.6262 41.4935 58.6262 29.5494C58.6262 22.8548 55.5838 16.8712 50.8071 12.9038",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAboutIcon1);
export default __webpack_public_path__ + "static/media/home-about-icon-1.351e551956ef210f398a3635f283e8c6.svg";
export { ForwardRef as ReactComponent };